import { render, staticRenderFns } from "./entegratorsecim.vue?vue&type=template&id=84974966&"
import script from "./entegratorsecim.vue?vue&type=script&lang=js&"
export * from "./entegratorsecim.vue?vue&type=script&lang=js&"
import style0 from "./entegratorsecim.vue?vue&type=style&index=0&id=84974966&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports